/** Mock data for development — used when backend APIs are not yet available */

const genTrend = (days = 10) => {
  const arr = []
  const base = new Date('2026-06-01')
  for (let i = 0; i < days; i++) {
    const d = new Date(base)
    d.setDate(d.getDate() + i)
    const dateStr = d.toISOString().slice(0, 10)
    const ndr = 400 + Math.round(Math.random() * 150)
    const interv = Math.round(ndr * (0.78 + Math.random() * 0.12))
    const deliv = Math.round(interv * (0.55 + Math.random() * 0.15))
    arr.push({
      date: dateStr,
      ndrRaised: ndr,
      interventions: interv,
      delivered: deliv,
      calls: 120 + Math.round(Math.random() * 60),
      connected: 80 + Math.round(Math.random() * 40),
      avgDuration: 75 + Math.round(Math.random() * 40),
      whatsappSent: 280 + Math.round(Math.random() * 80),
      totalCost: 20000 + Math.round(Math.random() * 8000),
      whatsapp: 1600 + Math.round(Math.random() * 400),
      sms: 400 + Math.round(Math.random() * 200),
      calls_futwork: 16000 + Math.round(Math.random() * 4000),
      calls_futworkAI: 0,
    })
  }
  return arr
}

const merchants = [
  { merchantOid: 'm1', merchantName: 'BoAt Lifestyle', totalNdr: 820, interventions: 710, deliveryRate: 64.2, frtAvg: 38, totalCalls: 340, connected: 238, connectRate: 70.0, whatsappSent: 580, totalCost: 52000, costPerDelivered: 7.40 },
  { merchantOid: 'm2', merchantName: 'Mamaearth', totalNdr: 610, interventions: 520, deliveryRate: 61.5, frtAvg: 52, totalCalls: 240, connected: 156, connectRate: 65.0, whatsappSent: 430, totalCost: 38000, costPerDelivered: 8.10 },
  { merchantOid: 'm3', merchantName: 'Lenskart', totalNdr: 540, interventions: 490, deliveryRate: 68.1, frtAvg: 29, totalCalls: 200, connected: 148, connectRate: 74.0, whatsappSent: 380, totalCost: 34500, costPerDelivered: 6.90 },
  { merchantOid: 'm4', merchantName: 'Sugar Cosmetics', totalNdr: 380, interventions: 310, deliveryRate: 59.8, frtAvg: 65, totalCalls: 160, connected: 96, connectRate: 60.0, whatsappSent: 280, totalCost: 28000, costPerDelivered: 9.20 },
  { merchantOid: 'm5', merchantName: 'Bewakoof', totalNdr: 290, interventions: 250, deliveryRate: 55.3, frtAvg: 88, totalCalls: 120, connected: 72, connectRate: 60.0, whatsappSent: 210, totalCost: 21000, costPerDelivered: 10.50 },
  { merchantOid: 'm6', merchantName: 'Plum Goodness', totalNdr: 210, interventions: 190, deliveryRate: 66.0, frtAvg: 41, totalCalls: 90, connected: 63, connectRate: 70.0, whatsappSent: 160, totalCost: 16500, costPerDelivered: 7.80 },
]

export const MOCK_DASHBOARD = {
  summary: {
    totalNdrRaised: 4520,
    totalNprRaised: 312,
    totalInterventions: 3890,
    interventionRate: 86.1,
    avgFRT_minutes: 47,
    frtP50_minutes: 32,
    frtP90_minutes: 128,
    deliverySuccessRate: 62.4,
    costPerDelivered: 8.40,
  },
  channelBreakdown: {
    whatsapp: { sent: 3200, actionTaken: 1120 },
    calls_futwork: { attempted: 1450, connected: 980, resolved: 640 },
    calls_futworkAI: { attempted: 0, connected: 0, resolved: 0 },
    manual: { actions: 520 },
    automated_rule: { triggered: 1890, reattempt: 1540, rto: 350 },
  },
  trend: genTrend(14),
  merchantBreakdown: merchants,
}

export const MOCK_CALL_ANALYTICS = {
  totalCalls: 1450,
  connected: 980,
  connectRate: 67.6,
  avgDuration_seconds: 94,
  uniqueAwbs: 1120,
  outcomeDistribution: {
    reattempt: 640,
    rto: 120,
    wrong_number: 85,
    escalation: 45,
    no_answer: 310,
    language_barrier: 30,
    other: 220,
  },
  dailyTrend: genTrend(14).map(d => ({ ...d, uniqueAwbs: Math.round(d.calls * 0.8) })),
  merchantBreakdown: merchants.map(m => ({ ...m, calls: m.totalCalls, uniqueAwbs: Math.round(m.totalCalls * 0.8) })),
}

export const MOCK_CALL_RECORDINGS = {
  recordings: [
    { awbNumber: 'AWB10234567', merchantName: 'BoAt Lifestyle', callStartTime: '2026-06-05T10:30:00', callEndTime: '2026-06-05T10:32:34', callDuration: 154, recordingUrl: '', outcome: 'reattempt', result: 'Reattempt', callResponses: [{ question: 'Is the customer available?', answer: 'Yes', positionInList: 1 }, { question: 'Would you like to reschedule delivery?', answer: 'Yes, tomorrow', positionInList: 2 }], provider: 'FUTWORK', attemptCount: 1 },
    { awbNumber: 'AWB10234890', merchantName: 'Mamaearth', callStartTime: '2026-06-05T11:15:00', callEndTime: '2026-06-05T11:16:42', callDuration: 102, recordingUrl: '', outcome: 'rto', result: 'RTO Initiated', callResponses: [{ question: 'Is the customer available?', answer: 'No', positionInList: 1 }], provider: 'FUTWORK', attemptCount: 2 },
    { awbNumber: 'AWB10235123', merchantName: 'Lenskart', callStartTime: '2026-06-05T12:00:00', callEndTime: '2026-06-05T12:01:08', callDuration: 68, recordingUrl: '', outcome: 'wrong_number', result: 'Wrong Number', callResponses: [], provider: 'FUTWORK', attemptCount: 1 },
    { awbNumber: 'AWB10235456', merchantName: 'Sugar Cosmetics', callStartTime: '2026-06-05T14:20:00', callEndTime: '2026-06-05T14:23:45', callDuration: 225, recordingUrl: '', outcome: 'reattempt', result: 'Reattempt', callResponses: [{ question: 'Updated address?', answer: 'Yes, flat 302, Tower B', positionInList: 1 }, { question: 'Preferred date?', answer: 'Tomorrow', positionInList: 2 }], provider: 'FUTWORK', attemptCount: 1 },
    { awbNumber: 'AWB10235789', merchantName: 'Bewakoof', callStartTime: '2026-06-06T09:10:00', callEndTime: '2026-06-06T09:10:45', callDuration: 45, recordingUrl: '', outcome: 'no_answer', result: 'No Answer', callResponses: [], provider: 'FUTWORK', attemptCount: 3 },
  ],
  total: 980,
  offset: 0,
  limit: 20,
}

export const MOCK_WHATSAPP = {
  totalSent: 3200,
  uniqueAwbs: 2210,
  engagement: {
    engagedConversations: 540,
    engagedAwbs: 470,
    engagementRate: 16.9,
  },
  outcomes: {
    reattempt: 360,
    rto: 150,
    engagedNoTerminalAction: 30,
  },
  templateBreakdown: [
    { templateName: 'NOT_DELIVERED_META_AUTOMATION', displayName: 'NDR Interaction', count: 2800 },
    { templateName: 'NOT_PICKEDUP_META_AUTOMATION', displayName: 'NPR Interaction', count: 400 },
  ],
  dailyTrend: genTrend(14).map(d => ({
    ...d,
    uniqueAwbs: Math.round(d.whatsappSent * 0.7),
    engaged: Math.round(d.whatsappSent * 0.17),
  })),
  merchantBreakdown: merchants.map(m => ({
    ...m,
    sent: m.whatsappSent,
    uniqueAwbs: Math.round(m.whatsappSent * 0.7),
    engaged: Math.round(m.whatsappSent * 0.17),
  })),
}

export const MOCK_TEMPLATES = [
  { channel: 'WHATSAPP', templateName: 'NOT_DELIVERED_META_AUTOMATION', displayName: 'NDR WhatsApp Interaction', provider: 'META', status: 'ACTIVE', usageCount30d: 28000, lastUsedDate: '2026-06-10', applicableTo: 'NDR', templateText: 'Hi {name}, your delivery for order {orderId} from {merchant} could not be completed. Reason: {reason}.\n\nPlease choose:\n1. Reschedule delivery\n2. Return to seller' },
  { channel: 'WHATSAPP', templateName: 'NOT_PICKEDUP_META_AUTOMATION', displayName: 'NPR WhatsApp Interaction', provider: 'META', status: 'ACTIVE', usageCount30d: 4200, lastUsedDate: '2026-06-10', applicableTo: 'NPR', templateText: 'Hi, pickup for order {orderId} from {merchant} could not be completed. Reason: {reason}.\n\nPlease choose:\n1. Reschedule pickup\n2. Cancel pickup' },
  { channel: 'SMS', templateName: 'NOT_DELIVERED', displayName: 'NDR SMS Notification', provider: 'ROUTE_MOBILE', templateId: '1207168xxxx', status: 'ACTIVE', usageCount30d: 12000, lastUsedDate: '2026-06-10', applicableTo: 'NDR' },
  { channel: 'SMS', templateName: 'DELIVERED', displayName: 'Delivery Confirmation SMS', provider: 'ROUTE_MOBILE', templateId: '1207168yyyy', status: 'ACTIVE', usageCount30d: 45000, lastUsedDate: '2026-06-10', applicableTo: 'NDR' },
  { channel: 'EMAIL', templateName: '30days_ndr_summary_email', displayName: 'NDR 30-Day Summary', provider: 'AWS_SES', status: 'ACTIVE', usageCount30d: 90, lastUsedDate: '2026-06-09', applicableTo: 'NDR' },
  { channel: 'EMAIL', templateName: '30days_ndr_daily_report', displayName: 'NDR Daily Report', provider: 'AWS_SES', status: 'ACTIVE', usageCount30d: 300, lastUsedDate: '2026-06-10', applicableTo: 'NDR' },
  { channel: 'EMAIL', templateName: '30days_npr_daily_report', displayName: 'NPR Daily Report', provider: 'AWS_SES', status: 'ACTIVE', usageCount30d: 120, lastUsedDate: '2026-06-10', applicableTo: 'NPR' },
  { channel: 'WHATSAPP', templateName: 'ORDER_PLACED_META', displayName: 'Order Placed Confirmation', provider: 'META', status: 'ACTIVE', usageCount30d: 85000, lastUsedDate: '2026-06-10', applicableTo: null },
]

export const MOCK_RULES = {
  totalMerchantsWithRules: 45,
  totalRulesActive: 128,
  totalRuleHits: 18900,
  hitRate: 72.4,
  actionDistribution: { reattempt: 15400, rto: 3500 },
  effectiveness: { reattemptToDelivered: 62.4, avgDaysToDeliveryAfterReattempt: 2.3 },
  merchantBreakdown: merchants.map(m => ({
    ...m,
    rulesActive: 3 + Math.floor(Math.random() * 5),
    ruleHits: 800 + Math.round(Math.random() * 600),
    hitRate: 65 + Math.round(Math.random() * 20),
    reattemptDeliveryRate: 55 + Math.round(Math.random() * 15),
  })),
}

export const MOCK_MERCHANT_RULE_CONFIG = {
  merchantName: 'BoAt Lifestyle',
  ndrRuleDefinition: {
    name: 'BoAt NDR Rules',
    status: 'ACTIVE',
    rules: [
      { name: 'Auto-reattempt customer unavailable', conditions: [{ fact: 'NDR_REMARK', operator: 'in', value: ['Customer Unavailable', 'Door Locked'] }, { fact: 'OFD_COUNT', operator: 'lte', value: 3 }], result: { action: 'REATTEMPT', preferredDeliveryDate: 1 } },
      { name: 'RTO after 3 failed attempts', conditions: [{ fact: 'OFD_COUNT', operator: 'gte', value: 3 }, { fact: 'DAYS_SINCE_FIRST_ATTEMPT', operator: 'gte', value: 5 }], result: { action: 'INITIATE_RTO' } },
      { name: 'Auto-reattempt COD incomplete address', conditions: [{ fact: 'NDR_REMARK', operator: 'in', value: ['Incomplete Address', 'Wrong Address'] }, { fact: 'PAYMENT_MODE', operator: 'eq', value: 'COD' }], result: { action: 'REATTEMPT', preferredDeliveryDate: 2 } },
    ],
  },
  whatsappAutomatedNdr: true,
  futworksNdrConfig: { pushLead: true, teleprojectId: 'TP-BOAT-001' },
  futworkAINdrConfig: { pushLead: false, campaignId: null },
  ndrManagedByProzo: true,
}

export const MOCK_COST = {
  totalCost: 245000,
  costPerDelivered: 8.40,
  channelBreakdown: {
    whatsapp: { totalCost: 19200, count: 32000, unitCost: 0.60 },
    sms: { totalCost: 4800, count: 24000, unitCost: 0.20 },
    ndr_calling: { totalCost: 189000, count: 14500, avgCostPerCall: 13.03 },
    npr_calling: { totalCost: 32000, count: 2800, avgCostPerCall: 11.43 },
  },
  dailyTrend: genTrend(14),
  merchantBreakdown: merchants,
}
